import { FormattedMessage } from "react-intl";
import type { LeadingGroup } from "./leading.js";
import { T } from "./texts.js";

/**
 * Škály po místech (CR-012 §6): místo s jednou škálou jako řádek s číslem místa, shoda jako jedno
 * místo s větou a názvy jako štítky. Mezivýsledek „Zatím vedou“ i souhrn Skici (Libor 19. 10. 2026).
 */
export function LeadingList({ groups, tieKey = "round.leadingTie" }: { groups: readonly LeadingGroup[]; tieKey?: string }) {
  return (
    <ol className="leading">
      {groups.map((g) => (
        <li key={g.place} className="leading__row" data-place={g.place}>
          <span className="leading__place" aria-hidden="true">
            {g.place}.
          </span>
          {g.scales.length === 1 ? (
            <span className="leading__name" data-scale={g.scales[0]}>
              <T k={`scale.${g.scales[0]}.name`} />
            </span>
          ) : (
            <div className="leading__tie">
              <span className="small muted">
                <FormattedMessage id={tieKey} />
              </span>
              <ul className="leading__chips">
                {g.scales.map((id) => (
                  <li key={id} className="leading__chip" data-scale={id}>
                    <T k={`scale.${id}.name`} />
                  </li>
                ))}
              </ul>
            </div>
          )}
        </li>
      ))}
    </ol>
  );
}
